import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { config } from "../../utils/Constants";
import TS from "../../utils/TimeStampGenerator";
import useErrorHandler from "../../components/ErrorHandler";
import { resetResponseState } from "../../features/responseSlice";
import useMerchantPortalAxios from "../../utils/axios";
import { setWebSocket } from "../../features/webSocketSlice";
import { setWebSocketToken } from "../store/slices/appSlice";

const getFirstFeatureSlug = () => {
  const fallback = "overview";

  try {
    const features = JSON.parse(sessionStorage.getItem("Features") || "[]");
    const firstPage = features
      ?.flatMap((category) => category?.Sections || [])
      ?.flatMap((section) => section?.Features || [])
      ?.find((feature) => feature?.IsPage && feature?.Slug);

    return firstPage?.Slug || fallback;
  } catch {
    return fallback;
  }
};

const useNewGenerateToken = () => {
  const { ErrorHandler } = useErrorHandler();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const client = useMerchantPortalAxios();

  const generateToken = async (sessionID, timerStatus) => {
    try {
      const res = await axios.post(
        `${config.url}/v1/Auth/GeneratePortalToken`,
        { SessionID: sessionID },
        {
          headers: {
            "content-type": "application/json",
          },
        },
      );

      const webSocketToken =
        res.data.Payload.WebSocketToken || res.data.Payload.WebSokcetToken || "";
      dispatch(setWebSocket(webSocketToken));
      dispatch(setWebSocketToken(webSocketToken));

      Object.entries(res.data.Payload || {}).forEach(([key, value]) => {
        sessionStorage.setItem(key, value);
      });

      navigate(`/${getFirstFeatureSlug()}`, { replace: true });
      return res;
    } catch (error) {
      clearInterval(timerStatus);
      ErrorHandler(error);
      throw error;
    }
  };

  const generateRefreshToken = async (sessionID, refreshToken) => {
    try {
      const res = await client.post("/v1/Auth/RefreshPortalToken", {
        RefreshToken: refreshToken,
        SessionID: sessionID,
        TS: TS(),
      });

      const token = res.data.Payload.Token;
      const tokenivs = btoa(process.env.REACT_APP_IVS_TOKEN);

      sessionStorage.setItem("Token", token);
      sessionStorage.setItem("IVSToken", tokenivs);
      sessionStorage.setItem("EntityRole", res.data.Payload.Role);
      sessionStorage.setItem("EntityType", res.data.Payload.EntityType);
      sessionStorage.setItem("EntityID", res.data.Payload.EntityID);

      return res;
    } catch (error) {
      sessionStorage.clear();
      dispatch(resetResponseState());
      toast.error("Your session has expired. Please login again.");
      navigate("/", { replace: true });
      throw error;
    }
  };

  return {
    generateToken,
    generateRefreshToken,
  };
};

export default useNewGenerateToken;
